import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import BackButton from './BackButton';

function RenderSubscriptionStatus(props) {
  if (props.subscription.status === "incomplete") {
    return (
      <div className="surface-card surface-card-padded">
        <span className="status-badge status-badge-warning">
          <span className="status-badge-dot"/> Incomplete
        </span>
        <p style={{margin: '14px 0 18px', color: 'var(--color-text-muted)'}}>
          You have a subscription that is incomplete. Please complete setting up a subscription.
        </p>
        <Link className="btn-brand btn-brand-primary" to={{
          pathname: "/paymentDetails",
          state: props.subscription
        }}>Complete subscription</Link>
      </div>
    );
  } else if (props.subscription.status === "past_due") {
    return (
      <div className="surface-card surface-card-padded">
        <span className="status-badge status-badge-danger">
          <span className="status-badge-dot"/> Past due
        </span>
        <p style={{margin: '14px 0 6px', color: 'var(--color-text-muted)'}}>
          You have a subscription that is past due. Please check your email and payment method to
          keep the subscription.
        </p>
        <p style={{margin: '0 0 18px', color: 'var(--color-text-muted)'}}>
          Alternatively, you can cancel the existing past due subscription and create a new one.
        </p>
        <Link className="btn-brand btn-brand-outline" to={{
          pathname: "/cancelSubscription",
          state: props.subscription
        }}>Cancel subscription</Link>
      </div>
    );
  } else if (props.subscription.status === "active") {
    return (
      <div className="surface-card surface-card-padded">
        <span className="status-badge status-badge-active">
          <span className="status-badge-dot"/> Active
        </span>

        <SubscriptionDetails subscription={props.subscription}/>

        <p style={{margin: '18px 0 14px', color: 'var(--color-text-muted)', fontSize: 14}}>
          You can cancel your subscription anytime.
        </p>
        <Link className="btn-brand btn-brand-outline" to={{
          pathname: "/cancelSubscription",
          state: props.subscription
        }}>Cancel subscription</Link>
      </div>
    );
  } else {
    return (
      <div className="alert callout callout-neutral">Unknown subscription status</div>
    )
  }
}


function SubscriptionDetails(props) {
  return (
    <div className="transaction-grid" style={{marginTop: 16}}>
      <div>
        <div className="transaction-field-label">Plan name</div>
        <div className="transaction-field-value">{props.subscription.planName}</div>
      </div>
      <div>
        <div className="transaction-field-label">Start date</div>
        <div className="transaction-field-value">{props.subscription.startDate}</div>
      </div>
    </div>
  );
}

class SubscriptionStatus extends Component {

  state = {
    isLoading: true,
    subscription: ''
  };

  componentDidMount() {
    this.fetchData()
  }

  async fetchData() {
    const response = await this.props.subscriptionApi.getSubscriptions()
    if (!response.ok) {
      this.setState({
          errorMessage: `Suscription status fetch failed: ${response.status} ${response.statusText}`,
          isLoading: false
        }
      )
    } else {
      const jsonData = await response.json();
      this.setState({
        isLoading: false,
        subscription: jsonData
      });
    }
  };

  render() {
    const {user} = this.props;
    const {errorMessage, isLoading, subscription} = this.state;

    return (
      <div className="app">
        {this.props.navbar}
        <div className="page-container">
          <BackButton/>
          <span className="page-eyebrow">Account</span>
          <h2 className="page-title">Account details</h2>

          {errorMessage &&
            <div className="alert callout callout-warning">{errorMessage}</div>
          }

          {isLoading ? (
            <div className="loading-row"><span className="spinner"/> Loading...</div>
          ) : (
            <div>
              <p className="page-subtitle">Hello <b>{user.name}</b></p>
              {subscription ?
                <RenderSubscriptionStatus subscription={subscription}/>
                :
                <div className="surface-card surface-card-padded">
                  <p style={{margin: '0 0 18px', color: 'var(--color-text-muted)'}}>
                    You are currently not subscribed. Please choose a plan to subscribe.
                  </p>
                  <Link className="btn-brand btn-brand-primary" to={"/subscriptionplans"}>Choose plan</Link>
                </div>
              }
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(SubscriptionStatus);
